import { marginSize } from '../../Utilities/utils/Theming';
import { StyleObject } from '../../Themes';
import { focusRing } from '../../Themes/base/focusRing';

export const drawerCloseStyles = (props: any) => {
	/* TODO review the properties forwarding */
	const closeOffset = props.offset
		? 'calc(var(--epods--drawer-close-spacing-top) + ' + props.offset + ')'
		: 'var(--epods--drawer-close-spacing-top)';
	return {
		cursor: 'pointer',
		position: 'relative',
		/* right: 'var(--epods--drawer-close-spacing-right)', */
		top: closeOffset,
		fill: 'var(--epods--color-text-primary) !important',
		':focus': focusRing,
	} as StyleObject;
};

export const drawerUtilitiesStyles = (props: any) => {
	/* TODO review the properties forwarding */
	const closeOffset = props.offset
		? 'calc(var(--epods--drawer-close-spacing-top) + ' + props.offset + ')'
		: 'var(--epods--drawer-close-spacing-top)';
	return {
		position: 'absolute',
		right: '3px',
		top: closeOffset,
	} as StyleObject;
};

export const drawerBodyStyle = (props: any, $theme: any) => {
	return {
		color: 'var(--epods--drawer-text-color)',
		fontFamily: 'var(--epods--font-base)',
		paddingTop: 'var(--epods--drawer-base-spacing-top)',
		paddingLeft: '2px',
		paddingRight: '2px',
		...marginSize(
			props.offset || '0px',
			props.noLateralMargins ? '0' : 'var(--epods--drawer-base-spacing-right)',
			'var(--epods--drawer-base-spacing-bottom)',
			props.noLateralMargins ? '0' : 'var(--epods--drawer-base-spacing-left)',
		),
	};
};

export const drawerContainerStyle = (shadow: any, $theme: any) => {
	return {
		boxShadow: shadow,
		backgroundColor: 'var(--epods--color-bg)',
		zIndex: 'var(--epods--zindex-drawer)'
	};
};

export const drawerTitlesText = (heading: string) => {
	return {
		fontSize: 'var(--epods--drawer-' + heading + '-size)',
		fontFamily: heading === 'h1' ? 'var(--epods--font-base-bold)' : 'var(--epods--font-base-semibold)',
		lineHeight: 'var(--epods--drawer-' + heading + '-height)',
		fontStyle: 'normal',
		letterSpacing: '0px',
		textAlign: 'left',
		marginBottom: '0px',
		marginTop: '0px',
	};
};
